<template>
  <div dir="rtl" class="report-container" v-if="!loading">
    <div class="report-header">
      <div class="header-stats">
        <div>عدد الواجبات: <strong>{{ counts.homeworks }}</strong></div>
        <div>عدد الأنشطة: <strong>{{ counts.activities }}</strong></div>
        <div>عدد الاختبارات: <strong>{{ counts.exams }}</strong></div>
      </div>
      <div class="header-center">
        <h2 class="text-white">تقرير أداء الطلاب الشامل</h2>
        <p>تاريخ التقرير {{ reportDate }}</p>
      </div>
    </div>
    <div class="actions-bar no-print">
      <b-dropdown
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        text="📥 طباعة / تصدير"
        variant="primary"
      >
        <b-dropdown-item @click="printReport()">
          <i class="fa fa-print"></i>
          طباعة التقرير
        </b-dropdown-item>
        <hr>
        <b-dropdown-item @click="exportToExcel()">
          <i class="fa fa-download"></i>
          تصدير التقرير اكسل
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="col-12 table-responsive" id="reportTable">
      <table class="report-table">
        <thead>
          <tr>
            <th colspan="3" class="group-header">المجموع</th>
            <th colspan="3" class="group-header">الاختبارات</th>
            <th colspan="3" class="group-header">الأنشطة</th>
            <th colspan="3" class="group-header">الواجبات</th>
            <th rowspan="2" class="fixed-header">النسبة</th>
            <th rowspan="2" class="fixed-header student-name-header">اسم الطالب</th>
            <th rowspan="2" class="fixed-header">م</th>
          </tr>
          <tr>
            <th class="sub-header">الكل</th>
            <th class="sub-header">غير مكتملة</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">غير مكتملة</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">غير مكتملة</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">غير مكتملة</th>
            <th class="sub-header">محلولة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, i) in students" :key="i">
            <td>{{ student.total.total }}</td>
            <td>{{ student.total.notCompleted }}</td>
            <td>{{ student.total.completed }}</td>
            <td>{{ student.exams.total }}</td>
            <td>{{ student.exams.notCompleted }}</td>
            <td>{{ student.exams.completed }}</td>
            <td>{{ student.activities.total }}</td>
            <td>{{ student.activities.notCompleted }}</td>
            <td>{{ student.activities.completed }}</td>
            <td>{{ student.homeworks.total }}</td>
            <td>{{ student.homeworks.notCompleted }}</td>
            <td>{{ student.homeworks.completed }}</td>
            <td :class="student.percentage === 0 ? 'td-danger' : 'td-success'">{{ student.percentage }}%</td>
            <td class="student-name">{{ student.name }}</td>
            <td>{{ i + 1 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="text-center p-5" dir="rtl">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3">جاري تحميل التقرير...</p>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: true,
      students: [],
      counts: { homeworks: 0, activities: 0, exams: 0 },
      reportDate: new Date().toISOString().split("T")[0],
      school_id: window.location.href.split("school_id=")[1]?.split("&")[0] || "",
    };
  },
  created() {
    var g = this;
    setTimeout(() => {
      $("body").append(
        `<textarea class='get-local-storage' name='fullReportData'></textarea>`
      );
      var i = setInterval(() => {
        if ($(`.get-local-storage-value[name='fullReportData']`).length) {
          clearInterval(i);
          try {
            var raw = $(`.get-local-storage-value[name='fullReportData']`).val();
            var data = JSON.parse(raw);
            g.counts = data.counts || { homeworks: 0, activities: 0, exams: 0 };
            g.students = data.students || [];
          } catch (e) {
            g.students = [];
          }
          g.loading = false;
        }
      }, 10);
    }, 500);
  },
  methods: {
    printReport() {
      var divToPrint = document.getElementById("reportTable");
      var headerHtml =
        `<div class="report-header">
          <div class="header-stats">
            <div>عدد الواجبات: <strong>${this.counts.homeworks}</strong></div>
            <div>عدد الأنشطة: <strong>${this.counts.activities}</strong></div>
            <div>عدد الاختبارات: <strong>${this.counts.exams}</strong></div>
          </div>
          <div class="header-center">
            <h2>تقرير أداء الطلاب الشامل</h2>
            <p>تاريخ التقرير: ${this.reportDate}</p>
          </div>
        </div>`;
      var tableHtml = divToPrint.outerHTML.replace('<table ', '<table dir="ltr" ');
      var newWin = window.open("");
      newWin.document.write(
        `<!DOCTYPE html><html lang="ar" dir="ltr"><head><meta charset="UTF-8"><style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          html, body { direction: ltr; font-family: 'Segoe UI', Tahoma, Arial, sans-serif; background: #fff; }
          .report-header {
            display: flex; justify-content: space-between; align-items: center;
            background: linear-gradient(135deg, #1a73a7, #2196f3);
            color: #fff; padding: 15px 25px; margin-bottom: 15px;
          }
          .header-center { text-align: center; flex: 1; }
          .header-center h2 { margin: 0 0 5px; font-size: 20px; }
          .header-center p { margin: 0; font-size: 13px; opacity: 0.9; }
          .header-stats { display: flex; flex-direction: column; gap: 3px; font-size: 12px; text-align: right; direction: rtl; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; direction: ltr; }
          th, td { border: 1px solid #bbb; white-space: nowrap; text-align: center; vertical-align: middle; }
          th { color: #fff; padding: 6px 4px; }
          .group-header { background: #1a73a7; font-size: 13px; }
          .sub-header { background: #2196f3; font-size: 11px; }
          .fixed-header { background: #1a73a7; font-size: 13px; }
          td { padding: 5px 4px; font-size: 12px; }
          tbody tr:nth-child(even) { background-color: #f2f8ff; }
          .student-name { text-align: right !important; font-weight: bold; color: #1a73a7; direction: rtl; }
          .td-danger { color: #dc3545; font-weight: bold; }
          .td-success { color: #198754; font-weight: bold; }
          @page { size: landscape; margin: 10mm; }
          @media print {
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          }
        </style></head><body dir="ltr">` +
        headerHtml +
        tableHtml +
        `</body></html>`
      );
      newWin.document.close();
      newWin.print();
    },
    exportToExcel() {
      var location = "data:application/vnd.ms-excel;base64,";
      var excelTemplate =
        '<html>' +
        "<head>" +
        '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>' +
        "</head>" +
        '<body style="direction:rtl;text-align:right;">' +
        document.getElementById("reportTable").outerHTML +
        "</body>" +
        "</html>";
      window.location.href =
        location + btoa(unescape(encodeURIComponent(excelTemplate)));
    },
  },
};
</script>

<style scoped>
.report-container {
  padding: 15px;
  background: #fff;
  direction: rtl;
}
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1a73a7, #2196f3);
  color: #fff;
  padding: 15px 25px;
  margin-bottom: 15px;
}
.header-center {
  text-align: center;
  flex: 1;
}
.header-center h2 {
  margin: 0 0 5px;
  font-size: 20px;
}
.header-center p {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}
.header-stats {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 12px;
}
.actions-bar {
  margin-bottom: 12px;
}
.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.report-table thead th {
  text-align: center;
  vertical-align: middle;
  color: #fff;
  padding: 6px 4px;
  white-space: nowrap;
}
.group-header {
  background: #1a73a7;
  font-size: 13px;
}
.sub-header {
  background: #2196f3;
  font-size: 11px;
}
.fixed-header {
  background: #1a73a7;
  font-size: 13px;
}
.student-name-header {
  min-width: 160px;
}
.report-table thead th,
.report-table tbody td {
  border: 1px solid #bbb;
}
.report-table tbody td {
  text-align: center;
  vertical-align: middle;
  padding: 5px 4px;
  white-space: nowrap;
}
.report-table tbody tr:nth-child(even) {
  background-color: #f2f8ff;
}
.report-table tbody tr:hover {
  background-color: #e3f0ff;
}
.student-name {
  text-align: left !important;
  font-weight: bold;
  color: #1a73a7;
  min-width: 160px;
}
.td-danger {
  color: #dc3545 !important;
  font-weight: bold;
}
.td-success {
  color: #198754 !important;
  font-weight: bold;
}
#date2 {
  display: none;
}
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
